module.exports = __webpack_public_path__ + "img/home1.47cbd7fe.png";